<template>
	<div class="flex flex-col h-full divide-y divide-gray-200 border-t">
		<div class="px-4 sm:px-6 pt-3 pb-6">
			<div class="flex justify-between">
				<button
					class="flex items-center font-medium text-orange-500"
					v-on:click="$emit('select-my-products')"
				>
					<!-- <ui-icon class="h-5 w-5 mr-2" name="corner-left-down" stroke-width="1.5" aria-hidden="true" /> -->
					{{ __("Select my products") }}
				</button>
				<button
					class="flex items-center font-medium text-orange-500"
					v-on:click.stop="$emit('filter-clear')"
				>
					{{ __("Clear selection") }}
					<ui-icon
						class="h-5 w-5 ml-2"
						name="delete"
						stroke-width="1.5"
						aria-hidden="true"
					/>
				</button>
			</div>

			<ui-button-select
				class="grid-cols-3 text-sm"
				v-model="filterProductGrades"
				:options="filterOptions.productGrades"
				:key="'productGrades-' + filterProductGrades.length"
			/>
		</div>
		<div class="px-4 sm:px-6 pt-3 pb-6" v-if="'proteinValues' in filterOptions">
			<h2>{{ __("Protein (only for B-WHEAT)") }}</h2>
			<ui-button-select
				class="grid-cols-3 text-sm"
				v-model="filter.proteinValues"
				:options="filterOptions.proteinValues"
				:key="'proteinValues-' + filter.proteinValues.length"
			/>
		</div>
		<div class="px-4 sm:px-6 pt-3 pb-6" v-if="'locationHubs' in filterOptions">
			<h2>{{ __("Market") }}</h2>
			<ui-button-select
				class="grid-cols-3 text-sm"
				v-model="filter.locationHubs"
				:options="filterOptions.locationHubs"
				:key="'locationHubs-' + filter.locationHubs.length"
			/>
		</div>
		<div class="px-4 sm:px-6 pt-3 pb-6">
			<h2>{{ __("Harvest Year") }}</h2>
			<ui-button-select
				class="grid-cols-3 text-sm"
				v-model="filter.productYears"
				:options="filterOptions.productYears"
				:key="'productYears-' + filter.productYears.length"
			/>
		</div>
		<div
			class="px-4 sm:px-6 pt-3 pb-6"
			v-if="'contractSources' in filterOptions"
		>
			<h2 class>{{ __("Contract Source") }}</h2>
			<ui-button-select
				class="grid-cols-2 sm:grid-cols-3 text-sm"
				v-model="filter.contractSources"
				:options="filterOptions.contractSources"
				:key="'contractSources-' + filter.contractSources.length"
			/>
		</div>
		<div class="px-4 sm:px-6 pt-3 pb-6">
			<div v-if="'locationModes' in filterOptions">
				<h2 class>{{ __("Location") }}</h2>
				<ui-button-select
					class="grid-cols-2 sm:grid-cols-3 text-sm"
					v-model="filter.locationModes"
					:options="filterOptions.locationModes"
					:key="'locationModes-' + filter.locationModes.length"
				/>
			</div>

			<span class="pt-2" v-if="filterOptions.showCity">
				<h2 class>{{ __("City") }}</h2>
				<ui-geocoder
					class="mt-1"
					:mapboxToken="mapboxToken"
					v-model="filter.location"
					ref="cityGeocoder"
				/>
				<div class="grid grid-cols-6 gap-x-4 pt-6 items-center">
					<ui-slider
						:max="1000"
						class="col-span-5"
						v-model="filter.location.distance_max"
					/>
					<div class="text-gray-500 text-right leading-4">
						{{ filter.location.distance_max }} km
					</div>
				</div>
			</span>
			<span class="pt-2" v-else-if="filterOptions.showCityOptions">
				<h2 class>{{ __("City") }}</h2>

				<ui-button-select
					class="grid-cols-2 sm:grid-cols-3 text-sm"
					v-model="filter.locationAddressCityOptions"
					:options="allCitySelectOptions"
					ref="clearMultiSelectTrigger"
					key="locationCity-allCityOptions"
				/>
			</span>
		</div>

		<div class="px-4 sm:px-6 pt-3 pb-6" v-if="'dateType' in filterOptions">
			<h2 class>{{ __("Fulfilment Date") }}</h2>

			<ui-button-select
				class="grid grid-cols-2 gap-x-4"
				v-model="filter.dateType"
				:options="filterOptions.dateType"
				:single="true"
				:key="'dateType-' + filter.dateType.length"
			/>

			<div
				v-if="showMonthPicker"
				class="mt-4 flex gap-x-4"
				:key="'fulfilmentDateRangeSelect-' + filter.monthType.length"
			>
				<ui-month-input-group
					v-model="filter.monthType.month_from"
					field="monthType.month_from"
					label="Month From"
					:form="filter"
					:required="true"
					vertical-alignment="bottom"
				></ui-month-input-group>

				<ui-month-input-group
					v-model="filter.monthType.month_to"
					field="monthType.month_to"
					label="Month To"
					:form="filter"
					:required="true"
					vertical-alignment="bottom"
				></ui-month-input-group>
			</div>
		</div>
		<div class="px-4 sm:px-6 pt-3 pb-6" v-if="'mine' in filter">
			<ui-check-group
				:form="filter"
				field="mine"
				v-model="filter.mine"
				label="My listings"
			/>
		</div>
		<div class="p-4 sm:p-6 mt-auto sticky z-10 bottom-0 bg-gray-100 shadow-xl">
			<ui-button
				class="w-full"
				type="primary"
				label="Apply Filter"
				v-on:click="$emit('filter-close')"
			></ui-button>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		filter: {
			type: Object,
		},
		filterOptions: {
			type: Object,
		},
		mapboxToken: {
			type: String,
		},
	},
	data() {
		return {};
	},
	computed: {
		showMonthPicker() {
			return this.filter.dateType?.includes("MONTH");
		},
		filterProductGrades: {
			get() {
				return "productGrades" in this.filter
					? this.filter.productGrades
					: this.filter.product.grade;
			},
			set(v) {
				if ("productGrades" in this.filter) {
					this.filter.productGrades = v;
				} else {
					this.filter.product.grade = v;
				}
			},
		},
		allCitySelectOptions() {
			return this.filterOptions.allCityOptions?.map(function (o) {
				return {
					value: o,
					label: o,
				};
			});
		},
	},
	mounted() {
		if (this.filterOptions.showCity) {
			let that = this;
			this.$on("clear-filter", function () {
				that.$refs.cityGeocoder.clear();
			});
		}
	},
	watch: {
		showMonthPicker(val) {},
	},
};
</script>
